import { render, staticRenderFns } from "./BoxLocationOverviewComparison.vue?vue&type=template&id=3687a0a7&"
import script from "./BoxLocationOverviewComparison.vue?vue&type=script&lang=js&"
export * from "./BoxLocationOverviewComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QBtnToggle} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QBtnToggle})
